import Vue from 'vue'

const sendMsg = (message, type) => {
  Vue.prototype.$message({
      type: type,
      message: message
  })
}

class Message {
    success(message) {
        sendMsg(message, 'success')
    }
    warning(message) {
        sendMsg(message, 'warning')
    }
    info(message) {
        sendMsg(message, 'info')
    }
    error(message) {
        sendMsg(message, 'error')
    }
}

export const message = new Message()